import { AuthRepository, ReportRepository } from "../../api";
import { Auth } from "../../models/lib/entities/Auth";
import { MenagementReport } from "../../models/lib/entities/MenagementReport";
import { MensurationReport } from "../../models/lib/entities/MensurationReport";
import { ComunicationReport } from "../../models/lib/entities/ComunicationReport";
import dom2img from 'dom-to-image';

export class ReportController {
	constructor(context) {
		this.context = context;

		this.generateReport 						= this.generateReport.bind(context);
		this.generateMenagementChart 		= this.generateMenagementChart.bind(context);
		this.generateComunicationChart 	= this.generateComunicationChart.bind(context);
		this.generateMensurationChart 	= this.generateMensurationChart.bind(context);
		this.generateGeralChart 				= this.generateGeralChart.bind(this);

		this.menagement;
		this.comunication;
		this.mensuration;

		this.reportRepo = new ReportRepository();
		this.createPDF = this.createPDF.bind(context);
		this.fetchPDF = this.fetchPDF.bind(context);
		this.renderPDF = this.renderPDF.bind(context);
	
	}

	generateMenagementChart() {
		const auth = this.props.auth;
		const governanceResponsibilitiesPoints = auth.governanceResponsibilitiesPoints;
		const businessPlanningPoints = auth.businessPlanningPoints;
		
		const menagement = new MenagementReport({governanceResponsibilitiesPoints, businessPlanningPoints});
		// menagement.generateChart("menagement");

		return menagement;
	}

	generateMensurationChart() {
		const auth 														= this.props.auth;

		const waterTreatmentPoints 						= auth.waterTreatmentPoints;
		const measurementSectorizationPoints 	= auth.measurementSectorizationPoints;
		const effluentTreatmentPoints 				= auth.effluentTreatmentPoints;
		const inputPoints 										= auth.inputPoints;
		const othersPoints 										= auth.othersPoints;
		
		const mensuration = new MensurationReport({waterTreatmentPoints, measurementSectorizationPoints, effluentTreatmentPoints, inputPoints, othersPoints});
		// mensuration.generateChart("mensuration");

		return mensuration;
	}
	
	generateComunicationChart() {
		const auth 								= this.props.auth;
		const engagementPoints 		= auth.engagementPoints;
		const comunicationPoints 	= auth.comunicationPoints;
		
		const comunication = new ComunicationReport({engagementPoints, comunicationPoints});
		// comunication.generateChart("comunication");

		return comunication;
	}


	compilateArray(obj) {
		const array = Object.keys(obj);
		const toReturn = [];
		
		for (var i = 0; i < array.length; i++) {
			for (var j = 0; j < obj[array[i]].length; j++) {
				toReturn.push(obj[array[i]][j]);
			}
		}
		return toReturn;
	}

	generateGeralChart(menagement, comunication, mensuration) {
		const toColors = {
			a: menagement.colors,
			b: comunication.colors,
			c: mensuration.colors,
		};

		const toPoints = {
			a: menagement.points,
			b: comunication.points,
			c: mensuration.points,
		};

		const toLabels = {
			a: menagement.labels,
			b: comunication.labels,
			c: mensuration.labels,
		};

		const colors = this.compilateArray(toColors);
		const points = this.compilateArray(toPoints);
		const labels = this.compilateArray(toLabels);
		// const state = this.context.getState();

		
		// this.context.callback(state);
		
		// this.generateReport("general", colors, points, labels);
		
		return  { id: "general", colors, points, labels };
	}

	generateReport(id, colors, points, labels, legend) {

		Chart.defaults.polarArea.animation.animateScale = false;
		Chart.defaults.polarArea.animation.animateRotate = false;
		Chart.defaults.polarArea.animation.startAngle = 0;

		var ctx = document.getElementById(id).getContext('2d');

		let min = -1;
		let max = 3;

		if(id == "general") {
			points = points.map(p => p + 1);
			max = 4;
		}

		var chart = new Chart(ctx, {
	    // The type of chart we want to create
	    type: 'polarArea',

	    // The data for our dataset
	    data: {
		    datasets: [{
		        data: points,
						backgroundColor: colors,
						borderColor: "rgba(255, 255, 255, .7)"
		    }],

		    // These labels appear in the legend and in the tooltips when hovering different arcs
		    labels: labels
			},

	    // Configuration options go here
	    options: {
				// maintainAspectRatio: false,
				// responsive: false,
	    	title: {
	        display: false,
	        text: 'Custom Chart Title'
	      },
	    	tooltips: {
	    		enabled: true
	    	},
	    	legend: {
	    		display: false,
	    		labels: {
	    			display: false
	    		}
	    	},
	    	scale: {
		    	ticks: {
		    		min,
		    		max,
				    stepSize: 1,
				    display: false
				    // fontColor: 'white'
        	}	    		
	    	}
	    }
		});
	}

	async createPDF(e) {
		e.preventDefault();

		if(!this.props.auth.pdfLink) {
			const report = document.getElementById("general-container");
			const management = document.getElementById("management-report-container");
			const measuring = document.getElementById("measuring-report-container");
			const comunication = document.getElementById("comunication-report-container");
			const title = document.getElementById("general-title");
			const footer = document.getElementById("footer-disclaimer");
			const textOne = document.getElementById("report-text-one");
			const pdfcontent = document.getElementById("pdf-content");

			const reportPng = await dom2img.toPng(report);
			const managementPng = await dom2img.toPng(management);
			const measuringPng = await dom2img.toPng(measuring);
			const comunicationPng = await dom2img.toPng(comunication);
			const titlePng = await dom2img.toPng(title);
			const footerPng = await dom2img.toPng(footer);
			const textOnePng = await dom2img.toPng(textOne);
			const pdfcontentPng = await dom2img.toPng(pdfcontent);

			const pdf = new jsPDF();
			const width = pdf.internal.pageSize.width;
			const height = pdf.internal.pageSize.height;

			const reportHeight = this.controller.getHeight(report, width);
			const managementtHeight = this.controller.getHeight(management, width);
			const measuringtHeight = this.controller.getHeight(measuring, width);
			const comunicationtHeight = this.controller.getHeight(comunication, width);
			const footerHeight = this.controller.getHeight(footer, width);

			let yOffset = 10;
			const xOffset = 10;
			const titleXOffset = 90;

			pdf.addImage(pdfcontentPng, "PNG", xOffset, yOffset);
			// yOffset += 10;
			// pdf.addImage(textOnePng, "PNG", xOffset, yOffset, 250, 250);
			// yOffset += 10;
			// pdf.addImage(reportPng, "PNG", 1, yOffset, width, reportHeight);
			// pdf.addPage();
			// yOffset = 10;
			// pdf.addImage(managementPng, "PNG", xOffset, yOffset, width, managementtHeight);
			// yOffset = 10;
			// pdf.addPage();
			// // yOffset += managementtHeight;
			// pdf.addImage(measuringPng, "PNG", xOffset, yOffset, width, measuringtHeight);
			// pdf.addPage();
			// yOffset = 10;
			// pdf.addImage(comunicationPng, "PNG", xOffset, yOffset, width, comunicationtHeight);
			// yOffset += 20;
			// pdf.addImage(footerPng, "PNG", 0, (height - footerHeight) * 0.95, width, footerHeight);
			pdf.save("relatorio_arca.pdf");
		}
	}

	getHeight(element, width) {
		return element.offsetHeight / element.offsetWidth * width;
	}

	async fetchPDF() {
		const response = await this.controller.reportRepo.getOne(this.props.auth.userId);
		return response.data;
		
	}

	async renderPDF() {
		let { reportUrl } = this.props.auth;
		if(!reportUrl) {
			reportUrl = await this.controller.fetchPDF();
		}
		this.setState({ reportUrl });
		PDFObject.embed(reportUrl, "#myPDF");
		
		// PDFObject.embed("http://www.pdf995.com/samples/pdf.pdf", "#myPDF");
		// PDFObject.embed(`/pdf?url=${encodeURIComponent("http://s3-us-west-2.amazonaws.com/arca-reports/GCUZ8N/arca-report.pdf")}`, "#myPDF");
	}
}



// WEBPACK FOOTER //
// src/controllers/lib/ReportController.js